var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnectionBars = function SvgConnectionBars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "connection-bars_svg__bar connection-bars_svg__bar-1",
    x: 2,
    y: 11,
    width: 2.5,
    height: 3,
    rx: 0.5,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "connection-bars_svg__bar connection-bars_svg__bar-2",
    x: 6.5,
    y: 7,
    width: 2.5,
    height: 7,
    rx: 0.5,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "connection-bars_svg__bar connection-bars_svg__bar-3",
    x: 11,
    y: 3,
    width: 2.5,
    height: 11,
    rx: 0.5,
    opacity: 0.3
  }))));
};
export default SvgConnectionBars;